




















































































































































































































import { Component, Prop, Inject } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { VueFilePondComponent } from "vue-filepond";
import { getModule } from "vuex-module-decorators";

import FormField from "@/lib/components/FormField.vue";
import FormErrors from "@/lib/components/FormErrors.vue";
import SubmitButton from "@/lib/components/SubmitButton.vue";

import dataStore from "@/store";
import PlushieStore from "@/modules/plushie/store";
import IdGenerator from "@/lib/services/id-generator";
import GeneralFormMixin from "@/lib/mixins/GeneralForm";
import Plushie from "@/modules/plushie/plushie.model";
import { UiPersisterStore } from "@/modules/ui-persister/store";

import AirwayBillUpload from "./CreateBulkShipmentForm/AirwayBillUpload.vue";
import CreateBulkShipmentFormSelectedItems from "./CreateBulkShipmentForm/SelectedItems.vue";
import CreateBulkShipmentFormSummary from "./CreateBulkShipmentForm/Summary.vue";
import CreateBulkShipmentFormSameOrdersPlushies from "./CreateBulkShipmentForm/SameOrdersPlushies.vue";

import BulkShipmentStore from "../store";
import BulkShipment from "../bulk-shipment.model";
import BulkShipmentBox from "../bulk-shipment-box.model";
import BulkShipmentItem from "../bulk-shipment-item.model";
import { BulkShipmentStatusValue } from "../bulk-shipment-status.value";
import DistributionCenter from "../distribution-center.model";

@Component({
  components: {
    AirwayBillUpload,
    FormField,
    FormErrors,
    SubmitButton,
    CreateBulkShipmentFormSelectedItems,
    CreateBulkShipmentFormSummary,
    CreateBulkShipmentFormSameOrdersPlushies,
  },
})
export default class CreateBulkShipmentForm extends mixins(GeneralFormMixin) {
  @Prop({ required: true })
  public readonly plushieIds!: string[];

  @Prop({ required: true })
  public readonly factoryId!: string;

  @Inject("IdGenerator")
  private fIdGenerator!: IdGenerator;

  public trackingNumber?: string;
  public airwayBill?: string;
  public distributionCenter = "";
  public carrier?: string;

  public boxNumber?: number;
  public boxLength?: number;
  public boxWidth?: number;
  public boxHeight?: number;
  public boxWeight?: number;

  public shouldCreateManifest = false;

  private fPlushieDataStore: PlushieStore;
  private fBulkShipmentDataStore: BulkShipmentStore;
  private fUiPersisterStore: UiPersisterStore;

  private fIsAirwayBillUploadInProgress = false;

  get isAirwayBillUploadProcessingInProgress(): boolean {
    return this.fIsAirwayBillUploadInProgress;
  }

  get distributionCenterOptions(): DistributionCenter[] {
    return this.fBulkShipmentDataStore.getDistributionCenterList.filter(
      (item) => item.isActive
    );
  }

  get selectedDistributionCenter(): DistributionCenter | undefined {
    if (!this.distributionCenter) {
      return undefined;
    }

    return this.fBulkShipmentDataStore.getDistributionCenterById(
      this.distributionCenter
    );
  }

  get isBoxParametersRequired(): boolean {
    return this.selectedDistributionCenter?.isBoxParametersRequired || false;
  }

  get isDisabled(): boolean {
    return (
      this.isAirwayBillUploadProcessingInProgress ||
      this.fIsDisabled ||
      this.disable
    );
  }

  get isUploadDisabled(): boolean {
    return this.fIsDisabled || this.disable;
  }

  get plushies(): Plushie[] {
    return this.fPlushieDataStore.getPlushiesByIds(this.plushieIds);
  }

  get persistedBoxNumber(): number | undefined {
    return this.fUiPersisterStore.getLastBulkShipmentBoxNumber;
  }

  set persistedBoxNumber(value: number | undefined) {
    this.fUiPersisterStore.updateLastBulkShipmentBoxNumber(value);
  }

  get persistedDistributionCenter(): string | undefined {
    return this.fUiPersisterStore.getLastBulkShipmentDistributionCenter;
  }

  set persistedDistributionCenter(value: string | undefined) {
    this.fUiPersisterStore.updateLastBulkShipmentDistributionCenter(value);
  }

  get persistedCarrier(): string | undefined {
    return this.fUiPersisterStore.getLastBulkShipmentCarrier;
  }

  set persistedCarrier(value: string | undefined) {
    this.fUiPersisterStore.updateLastBulkShipmentCarrier(value);
  }

  constructor() {
    super();
    this.fBulkShipmentDataStore = getModule(BulkShipmentStore, dataStore);
    this.fPlushieDataStore = getModule(PlushieStore, dataStore);
    this.fUiPersisterStore = getModule(UiPersisterStore, dataStore);
  }

  async created(): Promise<void> {
    await this.fBulkShipmentDataStore.loadDistributionCenters();
    this.restorePersistedValues();
  }

  public onAirwayBillUploadIsBusyChanged(value: boolean): void {
    this.fIsAirwayBillUploadInProgress = value;
  }

  public onCancelClick(): void {
    this.$emit("cancel");
  }

  protected async performSubmit(): Promise<void> {
    if (
      !this.trackingNumber ||
      !this.factoryId ||
      !this.plushies.length ||
      !this.carrier
    ) {
      return;
    }

    if (this.isBoxParametersRequired) {
      if (
        !this.boxNumber ||
        !this.boxLength ||
        !this.boxWidth ||
        !this.boxHeight ||
        !this.boxWeight
      ) {
        return;
      }
    }

    let bulkShipment = await this.fBulkShipmentDataStore.saveBulkShipment(
      new BulkShipment(
        this.fIdGenerator.getId(),
        this.factoryId,
        BulkShipmentStatusValue.DRAFT,
        this.distributionCenter,
        this.carrier
      )
    );

    if (this.isBoxParametersRequired) {
      if (
        this.boxNumber === undefined ||
        this.boxLength === undefined ||
        this.boxWidth === undefined ||
        this.boxHeight === undefined ||
        this.boxWeight === undefined
      ) {
        throw new Error("Box parameters are required but not provided");
      }

      await this.fBulkShipmentDataStore.saveBulkShipmentBox(
        new BulkShipmentBox(
          bulkShipment.id,
          this.boxNumber,
          this.boxLength,
          this.boxWidth,
          this.boxHeight,
          this.boxWeight
        )
      );
    }

    bulkShipment = await this.fBulkShipmentDataStore.editBulkShipment({
      id: bulkShipment.id,
      trackingNumber: this.trackingNumber,
      airwayBill: this.airwayBill,
      carrier: bulkShipment.carrier,
    });

    const bulkShipmentItems: BulkShipmentItem[] = [];

    this.plushies.forEach((plushie) => {
      const bulkShipmentItem = new BulkShipmentItem(
        this.fIdGenerator.getId(),
        bulkShipment.id,
        plushie.id,
        plushie.quantity
      );

      bulkShipmentItems.push(bulkShipmentItem);
    });

    await this.fBulkShipmentDataStore.saveBulkShipmentItems(bulkShipmentItems);

    await this.fBulkShipmentDataStore.publishBulkShipment(bulkShipment);

    this.persistedBoxNumber = this.boxNumber;
    this.persistedDistributionCenter = this.distributionCenter;
    this.persistedCarrier = this.carrier;

    if (this.shouldCreateManifest) {
      await this.fBulkShipmentDataStore.shipRequest(this.factoryId);
    }

    this.$emit("formSubmitted");
  }

  protected data(): Record<string, unknown> {
    return {
      trackingNumber: this.trackingNumber,
      carrier: this.carrier,
      airwayBill: this.airwayBill,
      boxNumber: this.boxNumber,
      boxLength: this.boxLength,
      boxWidth: this.boxWidth,
      boxHeight: this.boxHeight,
      boxWeight: this.boxWeight,
    };
  }

  private restorePersistedValues(): void {
    const persistedDistributionCenter = this.persistedDistributionCenter;

    if (persistedDistributionCenter) {
      const existingCenter = this.distributionCenterOptions.find(
        (center) => center.id === persistedDistributionCenter
      );

      if (existingCenter) {
        this.distributionCenter = persistedDistributionCenter;
      }
    }

    if (!this.distributionCenter) {
      const defaultCenter = this.fBulkShipmentDataStore
        .getDistributionCenterList[0];

      if (defaultCenter) {
        this.distributionCenter = defaultCenter.id;
      }
    }

    if (this.isBoxParametersRequired) {
      const persistedBoxNumber = this.persistedBoxNumber || 0;

      this.boxNumber = persistedBoxNumber + 1;
    }

    if (this.persistedCarrier) {
      this.carrier = this.persistedCarrier;
    }
  }

  private _getFileInput(): VueFilePondComponent | undefined {
    return (this.$refs["file-input"] as unknown) as VueFilePondComponent;
  }
}
